import React from 'react';
import { Link } from "react-router-dom";
import styled from "styled-components";

const SGrammarIndirecto = styled.div`
  flex: 1;
  padding: 5px 20px;
`;

const GrammarIndirecto = () => {
  return (
    <SGrammarIndirecto>
<h5>Estilo indirecto - Mowa zależna</h5>

<p>Mowa zależna to obcy dla nas, Polaków, sposób informowania o różnych wydarzeniach, uwzględniający zgodność czasu zaistnienia
 zdarzenia z czasem podawania informacji, występujący przy hiszpańskich czasach przeszłych. Tak więc kiedy my mówimy:
 "Powiedziała mi, że jest chora", Hiszpan w dosłownym tłumaczeniu mówi: "Powiedziała mi, że była chora".
 Czasy: <i><Link to="/grammar/indicativo#pre">Presente</Link></i> i <i><Link to="/grammar/indicativo#ppe">Pretérito Perfecto</Link></i>
 nie wymagają następstwa czasów, w przeciwieństwie do <i><Link to="/grammar/indicativo#pin">Pretérito Indefinido</Link></i>,
 <i><Link to="/grammar/indicativo#pim">Pretérito Imperfecto</Link></i> oraz
 <i><Link to="/grammar/indicativo#ppl">Pretérito Pluscuamperfecto</Link></i>. I tak każda forma osobowa występująca po tych czasach
 ma swój odpowiednik w mowie zależnej:</p>

<h6>Presente - Imperfecto</h6>
<i><b>Estoy</b> cansado</i> - Jestem zmęczony<br/>
<i>Dijo que <b>estaba cansado</b></i> - Powiedział, że jest zmęczony

<h6>Perfecto - Pluscuamperfecto</h6>
<i>No <b>he terminado</b></i> - Nie skończyłem<br/>
<i>Dijo que no <b>había terminado</b></i> - Powiedział, że nie skończył

<h6>Indefinido - Pluscuamperfecto</h6>
<i>Te <b>llamé</b> por teléfono</i> - Zadzwoniłem do ciebie<br/>
<i>Dijo que me <b>había llamado</b> por teléfono</i> - Powiedział, że zadzwonił do mnie

<h6>Futuro - Condicional</h6>
<i>Os <b>ayudaré</b></i> - Pomogę wam<br/>
<i>Dijo que nos <b>ayudaría</b></i> - Powiedział, że nam pomoże

<p>
Osobnym zagadnieniem jest mowa zależna występująca przy rozkazach i prośbach, ale tą kwestią zajmiemy się innym razem.
</p>
    </SGrammarIndirecto>
  )
};

export default GrammarIndirecto;